import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'comp.ChangeThumbnailDialog.title',
    defaultMessage: 'Change thumbnail',
  },
  explainer: {
    id: 'comp.ChangeThumbnailDialog.explainer',
    defaultMessage:
      'Upload an image to use as this asset’s thumbnail everywhere in FileSpin. Your thumbnail is kept even when the file itself is replaced.',
  },
  cacheNote: {
    id: 'comp.ChangeThumbnailDialog.cacheNote',
    defaultMessage:
      'FileSpin shows a new thumbnail straight away. Links already used outside FileSpin (websites, emails) can show the previous image for up to 2 days while browser and CDN caches expire.',
  },
  currentLabel: {
    id: 'comp.ChangeThumbnailDialog.currentLabel',
    defaultMessage: 'Current',
  },
  newLabel: {
    id: 'comp.ChangeThumbnailDialog.newLabel',
    defaultMessage: 'New',
  },
  customBadge: {
    id: 'comp.ChangeThumbnailDialog.customBadge',
    defaultMessage: 'Custom thumbnail in use',
  },
  upload: {
    id: 'comp.ChangeThumbnailDialog.upload',
    defaultMessage: 'Use this thumbnail',
  },
  processing: {
    id: 'comp.ChangeThumbnailDialog.processing',
    defaultMessage: 'Processing…',
  },
  uploaded: {
    id: 'comp.ChangeThumbnailDialog.uploaded',
    defaultMessage: 'Thumbnail updated. Links used outside FileSpin may show the previous image for up to 2 days.',
  },
  uploadFailed: {
    id: 'comp.ChangeThumbnailDialog.uploadFailed',
    defaultMessage: 'Could not update the thumbnail. Please try again.',
  },
  revert: {
    id: 'comp.ChangeThumbnailDialog.revert',
    defaultMessage: 'Revert to automatic thumbnail',
  },
  reverted: {
    id: 'comp.ChangeThumbnailDialog.reverted',
    defaultMessage: 'Thumbnail reverted to automatic. Links used outside FileSpin may show the previous image for up to 2 days.',
  },
  orStoryboard: {
    id: 'comp.ChangeThumbnailDialog.orStoryboard',
    defaultMessage: 'Or use a frame from the video:',
  },
  chooseFrame: {
    id: 'comp.ChangeThumbnailDialog.chooseFrame',
    defaultMessage: 'choose from {count, plural, one {the storyboard frame} other {# storyboard frames}}',
  },
  revertFailed: {
    id: 'comp.ChangeThumbnailDialog.revertFailed',
    defaultMessage: 'Could not revert the thumbnail. Please try again.',
  },
});
